import { Component, OnInit, ViewChild } from '@angular/core';

import { TitleService } from '@shared/services/title.service';
import { SessionService } from '@app/shared/services/session.service';
import { MenuService } from '@app/shared/services/menu.service';
import * as moment from 'moment/moment';
import { StateOfCarService } from '@app/shared/services/state-of-car.service';
import { DateService } from '@app/shared/services/date.service';
import { ReservationsService } from '@app/shared/services/reservations.service';
import { AlertService } from '@app/shared/services/alert.service';
import { CreatedReservation, ReservationPlannerComponent } from '@app/components/reservation-planner/reservation-planner.component';
declare var UIkit: any;

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  public today: string = moment().format();

  /* Sinisters */

  public dateStart: string = moment().subtract(30, 'days').format('DD/MM/YYYY').split('T')[0];
  public dateEnd: string = moment().format('DD/MM/YYYY').split('T')[0];
  public loadingStatus: boolean = false;
  public noResult: boolean = false;
  public sinisters: Array<any> = [];

  @ViewChild(ReservationPlannerComponent) private planner: ReservationPlannerComponent;

  /* Planner state */

  public plannerMode: 'create' | 'select' = 'select';
  public plannerSocietyId: number = 0;
  public plannerAccountTarget: number | undefined = undefined;
  public plannerCustomerName: string = '';
  public plannerSocietyName: string = '';

  get plannerCreateModeLabel(): string {
    if (this.plannerMode !== 'create' || !this.plannerCustomerName) { return ''; }
    const parts = [this.plannerCustomerName];
    if (this.plannerSocietyName) { parts.push(this.plannerSocietyName); }
    return 'Ajout de réservation : ' + parts.join(' — ');
  }

  get isSuperAdmin(): boolean {
    return this.sessionService.role.ability === 'super-admin';
  }

  constructor(
    private titleService: TitleService,
    public sessionService: SessionService,
    public menu: MenuService,
    private stateOfCarService: StateOfCarService,
    private dateService: DateService,
    private reservationsService: ReservationsService,
    private alertService: AlertService
  ) { }

  ngOnInit() {
    this.titleService.setTitle(`Tableau de bord / VOP`);
    this.menu.setMenuState('dashboard', 'activity', '');
    this.updateSinisters();

    // Admin: society ID comes from session permissions.
    // Super-admin: role.id = -1, so idSocietyVop guard in the planner omits the filter
    // and the backend returns all vehicles.
    this.plannerSocietyId   = this.sessionService.role.id;
    this.plannerSocietyName = this.sessionService.role.name;
  }

  updateSinisters() {
    this.loadingStatus = true;
    this.stateOfCarService.updateStateOfCarByDates(
      moment(this.dateStart, 'DD/MM/YYYY').format().split('T')[0],
      moment(this.dateEnd, 'DD/MM/YYYY').format().split('T')[0],
      -1
    ).then((res) => {
      this.loadingStatus = false;
      if (this.stateOfCarService.stateOfCarCount === 0) {
        this.noResult = true;
      } else {
        this.sinisters = res.slice(0, 2);
        this.sinisters = this.dateService.convertAlltoLocal(this.sinisters);

        console.log(this.sinisters);
        this.noResult = false;
      }
    });
  }

  openFindUserModal() {
    UIkit.modal('#find-user').show();
  }

  onFindUserConfirmed(payload: any) {
    if (this.isSuperAdmin) {
      // payload = { user, societyId, societyName }
      this.plannerAccountTarget = payload.user.AccountId;
      this.plannerCustomerName  = payload.user.FirstName + ' ' + payload.user.LastName;
      this.plannerSocietyId     = payload.societyId;
      this.plannerSocietyName   = payload.societyName;
    } else {
      // payload = user object directly
      this.plannerAccountTarget = payload.AccountId;
      this.plannerCustomerName  = payload.FirstName + ' ' + payload.LastName;
    }
    this.plannerMode = 'create';
  }

  onPlannerCancelled() {
    this.plannerMode          = 'select';
    this.plannerAccountTarget = undefined;
    this.plannerCustomerName  = '';
  }

  onReservationCreated(payload: CreatedReservation) {
    this.reservationsService.createReservation({
      idStation:       payload.idStation,
      idVehicle:       payload.idVehicle,
      begin:           payload.begin,
      end:             payload.end,
      comment:         payload.comment || '',
      packIds:         [],
      idAccountTarget: payload.idAccountTarget
    }).then((res: any) => {
      if (res && res.success === false) {
        this.planner?.notifyCreationError();
        alert(res.message || 'Erreur lors de la création.');
      } else {
        this.planner?.notifyCreationSuccess();
        this.alertService.alert('Réservation créée avec succès.');
        this.onPlannerCancelled();
      }
    }).catch(() => {
      this.planner?.notifyCreationError();
      alert('Erreur lors de la création de la réservation.');
    });
  }

  logout() {
    this.sessionService.logout();
  }

}
